import { types, flow } from "mobx-state-tree";
import { values } from "mobx";
import axios from "../../store/axios";
import { FieldModel } from "../../store/ListField.model";

export const AdminTrainerListStoreInitial = {
    list: [],
    currentPage: 1,
};

// 목록(search)과 명단 엑셀(downloadExcel)이 같은 필터를 같은 쿼리로 서버(ListBaseController.GetFilter)에 보낸다.
// 만드는 곳이 둘이면 "목록에서 본 사람들"과 "받은 파일의 사람들"이 어긋나므로 한 곳에서 만든다.
// 반환은 `&key=value…` 이어 붙이는 꼴이다 (필터가 없으면 빈 문자열). 값은 사용자가 친 글자라 &·#·+·한글이 들어올 수 있어 인코딩한다.
export const buildTrainerFilterQuery = ({
    displayName,
    brand,
    dealer,
    branch,
    professionalityId,
} = {}) => {
    let query = "";
    if (displayName) {
        query += `&displayName_like=${encodeURIComponent(displayName)}`;
    }
    if (brand) {
        query += `&brand_like=${encodeURIComponent(brand)}`;
    }
    if (dealer) {
        query += `&dealer_like=${encodeURIComponent(dealer)}`;
    }
    if (branch) {
        query += `&branch_like=${encodeURIComponent(branch)}`;
    }
    if (professionalityId && professionalityId !== "ALL") {
        query += `&professionality__=${encodeURIComponent(professionalityId)}`;
    }
    return query;
};


const AdminTrinerListEntry = types.model("AdminTraineeTestApplyEntry", {
    id: types.identifierNumber,
    displayName: types.string,
    brand: types.string,
    dealer: types.string,
    branch: types.string,
    enterYear: types.integer,
    highSchool: types.string,
    university: types.string,
    phoneNumber: types.string,
    birthday: types.Date,
    professionality: types.string,
    professionalityId: types.integer,
});

export const AdminTrainerListStore = types
    .model("AdminTrainerListStore", {
        list: types.array(AdminTrinerListEntry),
        fields: types.array(FieldModel),
        currentPage: types.integer,
    })
    .views((self) => ({
        get List() {
            return values(self.list);
        },
        get Pages() {
            return self.pages;
        },
    }))
    .actions((self) => {
        return {
            decline: flow(function* (id) {
                // const rootStore = getParent(self, 1);
                console.log("quit", id);
                const url = `/admin-trainer/quit/${id}`;
                const response = yield axios.put(
                    url
                );
                console.log(url, response.data);
            }),
            confirm: flow(function* (id) {
                // const rootStore = getParent(self, 1);
                console.log("confirm", id);
                const url = `/transfer-request/allow-transfer/${id}`;
                yield axios.put(
                    url
                );
            }),
            search: flow(function* (
                displayName,
                brand,
                dealer,
                branch,
                professionalityId,
                page
                ) {
                // const rootStore = getParent(self, 1);
                console.log("search page", page);
                const queryString =
                    `/admin-trainer/list?_page=${page}&_limit=24` +
                    buildTrainerFilterQuery({
                        displayName,
                        brand,
                        dealer,
                        branch,
                        professionalityId,
                    });
                console.log("queryString ", queryString);
                const response = yield axios.get(
                    queryString
                );
                console.log("AdminTrinerList ", response.data);
                self.pages = response.data.pages;
                 // Convert UTC birthday to local time
                const list = response.data.list.map(item => {
                    const date = new Date(item.birthday);
                    item.birthday = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
                    return item;
                });
                return list; 
            }),
            // 지금 필터에 맞는 전체 명단(페이지 없음, 퇴사자 포함)을 xlsx Blob 으로 받는다. 서버: TrainerListController.Export (Admins)
            downloadExcel: flow(function* (filters) {
                const query = buildTrainerFilterQuery(filters).replace(/^&/, "");
                const response = yield axios.get(
                    `/admin-trainer/export?${query}`,
                    { responseType: "blob" }
                );
                return response.data;
            }),
        };
    });

export default AdminTrainerListStore;
